<template>
  <div>
    <form-create v-model="createForm" :rule="rules" :option="option" />
  </div>
</template>

<script>
export default {
  name: 'UdpForm',
  props: {
    rules: {
      type: Array,
      default: () => {
        return []
      }
    },
    queryForm: Object
    // 请求参数
  },
  data() {
    return {
      createForm: this.queryForm, 
      // 请求参数
      option: { 
        // 禁用form-create
        submitBtn: false,
        resetBtn: false
      }
    }
  },
  watch: {
    default(val) {

    }
  },
  created() {

  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.rules.forEach((element) => {
        // 初始化列宽
        this.initCol(element)

        // 初始化文本框提示
        this.initPlaceholder(element)

      })

      // 重新加载表单
      this.createForm.reload(this.rules)
    },
    initCol(element) { 
      // 初始化列宽
      if (element.col == null) {
        element.col = {
          span: 8,
          labelWidth: '80px'
        }
      }
      if (!element.col.span) {
        element.col.span = 8
      }
      if (!element.col.labelWidth) {
        element.col.labelWidth = '80px'
      }
    },
    initPlaceholder(element) {
      let placeholder = ''
      if (element.type == 'input') {
        placeholder = '请输入' + element.title
      } else {
        placeholder = '请选择' + element.title
      }

      if (element.props.placeholder == null) {
        element.props.placeholder = placeholder
      }
      if (element.placeholder != null) {
        element.props.placeholder = element.placeholder
      }
    },
    getFormData() {
      return this.createForm.formData()
    },
    resetFields() {
      return this.createForm.resetFields()
    },
    selectChange(field, value) {
      this.createForm.setValue(field, value)
    },
    setPropsValue(field, value) {
      this.createForm.setValue(field, value)
    },
    cascade(field, key, value, defaultValue) {
      // 1、获取当前field
      const rule = this.createForm.getRule(field)

      // 设置当前属性的值，通过监听改变表单属性
      this.createForm.set(rule.props, key, value)

      // 组件默认值
      if (defaultValue) {
        this.createForm.set(rule.props, 'value', defaultValue)
      }
    }

  }
}
</script>
